import { useState } from "react";

import SideBar from "./SideBar";
import BellSVG from "./svg/BellSVG";
import DropDownSVG from "./svg/DropDownSVG";
import LogoSVG from "./svg/LogoSVG";
import MailSVG from "./svg/MailSVG";
import ProfileSVG from "./svg/ProfileSVG";

const Navbar = ({ userName }) => {
  const [sideBarActive, setSideBar] = useState(!userName && "disabled");

  const handleClick = (e) => {
    if (userName) {
      setSideBar(!sideBarActive);
    }
  };
  return (
    <>
      <nav className="navbar" aria-label="Site Menu">
        <div className="navbar__left">
          {userName && (
            <svg
              className="navbar__hamburger"
              onClick={handleClick}
              viewBox="0 0 100 80"
              width="40"
              height="40"
            >
              <rect width="100" height="8"></rect>
              <rect y="30" width="100" height="8"></rect>
              <rect y="60" width="100" height="8"></rect>
            </svg>
          )}
          <LogoSVG className="navbar__logo"/>
        </div>
        {userName && (
          <ul className="navbar__right">
            <li className="navbar__link">
              <MailSVG className="navbar_mail-icon"/>
            </li>
            <li className="navbar__link">
              <BellSVG className="navbar_mail-icon"/>
            </li>
            <li className="navbar__profile">
              <ProfileSVG className="navbar__profile-icon"/>
              <p className="navbar__username">{userName}</p>
              <DropDownSVG className="dropdown-icon"/>
            </li>
          </ul>
        )}
      </nav>
      <SideBar active={sideBarActive} />
    </>
  );
};

export default Navbar;
